import { render, staticRenderFns } from "./Paygw_status.vue?vue&type=template&id=721765f4&scoped=true"
import script from "./Paygw_status.vue?vue&type=script&lang=js"
export * from "./Paygw_status.vue?vue&type=script&lang=js"
import style0 from "./Paygw_status.vue?vue&type=style&index=0&id=721765f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721765f4",
  null
  
)

export default component.exports